import { gql } from "@apollo/client";
import { useLazyQuery } from "@apollo/client/react";
import { createContext, useContext, useEffect } from "react";

import { useAuth } from "./use-auth";

const USER_QUERY = gql`
  query UserNoteUsageQuery {
    user {
      uuid
      shouldUseAutoSoaps
      totalNotesCreated
    }
  }
`;

const noteUsageContext = createContext();

// Hook for child components to get the auth object ...
// ... and re-render when it changes.
export const useNoteUsage = () => {
  return useContext(noteUsageContext);
};

export function useProvideNoteUsage() {
  const [getNoteUsage, { data }] = useLazyQuery(USER_QUERY, {
    fetchPolicy: "no-cache",
  });

  const { isUserAuthenticated } = useAuth();

  useEffect(() => {
    if (isUserAuthenticated) {
      getNoteUsage();
    }
  }, [isUserAuthenticated, getNoteUsage]);

  return {
    shouldUseAutoSoaps: data?.user?.shouldUseAutoSoaps,
    totalNotesCreated: data?.user?.totalNotesCreated,
  };
}

export function NoteUsageProvider({ children }) {
  const noteUsage = useProvideNoteUsage();

  return (
    <noteUsageContext.Provider value={noteUsage}>
      {children}
    </noteUsageContext.Provider>
  );
}
